import { Input } from '@/components/ui/input';
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '@/components/ui/select';
import { ZoneFilterSelect } from '../shared/ZoneFilterSelect';
import type { Zone, ItemStatus } from '../../types';

const itemStatuses: { value: ItemStatus | 'all'; label: string }[] = [
  { value: 'all', label: 'All Statuses' },
  { value: 'valid', label: 'Valid' },
  { value: 'verify', label: 'Verify' },
  { value: 'test', label: 'Test' },
  { value: 'dev', label: 'Dev' },
  { value: 'dead', label: 'Dead' },
];

interface InventoryFiltersProps {
  search: string;
  onSearchChange: (value: string) => void;
  zoneId: string;
  onZoneChange: (value: string) => void;
  status: string;
  onStatusChange: (value: string) => void;
  lowStockOnly: boolean;
  onLowStockChange: (value: boolean) => void;
  zones: Zone[];
}

export function InventoryFilters({
  search,
  onSearchChange,
  zoneId,
  onZoneChange,
  status,
  onStatusChange,
  lowStockOnly,
  onLowStockChange,
  zones,
}: InventoryFiltersProps) {
  return (
    <div className="flex items-center gap-3 flex-wrap">
      <Input
        placeholder="Search SKU, name..."
        value={search}
        onChange={(e) => onSearchChange(e.target.value)}
        className="max-w-sm h-8"
      />
      <ZoneFilterSelect value={zoneId} onChange={onZoneChange} zones={zones} />
      <Select value={status} onValueChange={onStatusChange}>
        <SelectTrigger className="w-[130px] h-8">
          <SelectValue placeholder="Status" />
        </SelectTrigger>
        <SelectContent>
          {itemStatuses.map((s) => (
            <SelectItem key={s.value} value={s.value}>
              {s.label}
            </SelectItem>
          ))}
        </SelectContent>
      </Select>
      <label className="flex items-center gap-2 text-sm cursor-pointer">
        <input
          type="checkbox"
          checked={lowStockOnly}
          onChange={(e) => onLowStockChange(e.target.checked)}
          className="rounded"
        />
        Low stock only
      </label>
    </div>
  );
}
